const tour = document.querySelector('.popup__simple tour')
const isBookModal = document.querySelector('.book-modal')

if (tour) {
  const tourUrl = tour.getAttribute('data-url')
}
document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.header__button');
  const popup = document.querySelector('.header__popup');
  const closeButton = document.querySelector('.header__popup-close');
  menuButton.addEventListener('click', () => {
    if (!isBookModal) {
      popup.classList.toggle('open');
    } else {
      bookDemoModal()
    }
  });

  closeButton.addEventListener('click', () => {
    popup.classList.remove('open');
  });

});

////////////////////////

const bookDemoModal = () => {
  const popup = document.querySelector('#contact-form');
  if (!popup) return;
  popup.classList.add('open');
}

document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('.header__popup-menu a');
  const headerContacts = document.querySelectorAll('.header__contact');
  const footerPdf = document.querySelector('.footer__price');
  const headerPopup = document.querySelector('.header__popup');

  menuLinks.forEach(link => {
    const href = link.getAttribute('href');

    if (!href || !href.startsWith('#')) return;

    link.addEventListener('click', (e) => {
      const popup = document.querySelector(href);

      if (link.parentElement.classList.contains('pdf-link') && window.innerWidth < 900) {
        e.preventDefault();
        window.open(
          'https://clearviewdrive.app/wp-content/uploads/2026/03/Clear-View-Drive-Collateral.pdf',
          '_blank',
          'noopener'
        );
        headerPopup.classList.remove('open');
        return;
      }


      if (!popup) return;

      if (popup.classList.contains('tour')) {
        tour.setAttribute('src', tourUrl)
      }

      e.preventDefault();
      if (headerPopup) {
        headerPopup.classList.remove('open');
      }
      popup.classList.add('open');
    });
  });
  headerContacts.forEach(headerContact => {
    headerContact.addEventListener('click', (e) => {
      e.preventDefault();
      bookDemoModal()
    })
  })




  footerPdf.addEventListener('click', (e) => {
    if (!isBookModal) {
      const href = footerPdf.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const popup = document.querySelector(href);
      if (!popup) return;
      e.preventDefault();
      popup.classList.add('open');
    } else {
      bookDemoModal()
    }
  })

  const footerPlan = document.querySelector('.footer__plan');
  footerPlan && footerPlan.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const footerButtons = document.querySelector('.footer__buttons');
    const spinnerIframe = document.querySelector('.spinner iframe');
    if (!spinnerIframe || !spinnerIframe.contentWindow) return;
    if (footerButtons && footerButtons.classList.contains('tour-open')) {
      spinnerIframe.contentWindow.postMessage({ type: "OPEN_FLOORPLAN" }, "*");
    }
  })

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('popup__contact-close')) {
      const popup = e.target.closest('.popup__contact');
      popup.classList.remove('open');
    }
  })

  const showCopied = (el) => {
    const original = el.textContent;
    el.textContent = 'Copied!';
    el.classList.add('is-copied');
    setTimeout(() => {
      el.textContent = original;
      el.classList.remove('is-copied');
    }, 1500);
  };

  const fallbackCopy = (el, email) => {
    const textarea = document.createElement('textarea');
    textarea.value = email;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    showCopied(el);
  };

  const copyEmail = (el) => {
    const email = (el.getAttribute('data-email') || el.textContent || '').trim();
    if (!email) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(email).then(() => {
        showCopied(el);
      }).catch(() => {
        fallbackCopy(el, email);
      });
      return;
    }

    fallbackCopy(el, email);
  };

  document.addEventListener('click', (e) => {
    const emailLink = e.target.closest('.js-copy-email');
    if (!emailLink) return;
    e.preventDefault();
    e.stopPropagation();
    copyEmail(emailLink);
  });


  const iframe = document.querySelector('iframe');
  window.addEventListener('blur', () => {
    if (document.activeElement === iframe) {
      if (headerPopup) {
        headerPopup.classList.remove('open');
      }
    }
  });
});

document.addEventListener('click', (e) => {
  if (e.target.classList.contains('popup__simple-close')) {
    const popup = e.target.closest('.popup__simple');

    if (popup.classList.contains('tour')) {
      tour.removeAttribute('src')
    }


    popup.classList.remove('open');
  }
});

document.addEventListener('wpcf7mailsent', function (event) {
  const popup = event.target.closest('.popup__contact');
  const thanksBlock = popup.querySelector('.popup__thanks');
  const form = event.target;

  if (thanksBlock) {
    thanksBlock.classList.add('active');
  }
  popup.classList.add('thanks');

  setTimeout(() => {
    form.dispatchEvent(new Event('reset'));
    popup.classList.remove('open')
    if (thanksBlock) {
      thanksBlock.classList.remove('active');
      popup.classList.remove('thanks');
    }

  }, 5000);
});


window.addEventListener("message", function (event) {
  if (event.data.type === "OPEN_WP_MODAL") {


    const popup = document.querySelector('.popup__contact');
    popup.classList.add('open')
  }
});
window.addEventListener("message", function (event) {
  if (event.data.type === "OPEN_WP_PDF") {


    const popup = document.querySelector('.popup__contact.second');
    popup.classList.add('open')
  }
});


const apartmentsLink = document.querySelector('.apartments-link')
apartmentsLink && apartmentsLink.addEventListener('click', (e) => {
  e.preventDefault()
  const iframe = document.querySelector('.spinner iframe');
  const headerPopup = document.querySelector('.header__popup');
  if (iframe && headerPopup) {
    iframe.contentWindow.postMessage(
      { type: "APARTMENTS" },
      window.location.origin
    );

    headerPopup.classList.remove('open');
  }
})

const dismissIntroBanner = () => {
  const bannerSection = document.querySelector('.banner');
  if (!bannerSection || bannerSection.classList.contains('dn')) return;

  const url = new URL(window.location.href);
  if (!url.searchParams.has('masterplan')) {
    url.searchParams.set('masterplan', '1');
    window.history.pushState({}, '', url);
  }

  bannerSection.classList.add('hidden');
  setTimeout(() => {
    bannerSection.classList.add('dn');
  }, 600);
};

const showIntroBanner = () => {
  const headerPopup = document.querySelector('.header__popup');
  if (headerPopup) headerPopup.classList.remove('open');

  document.querySelectorAll('.popup__simple.open, .popup__contact.open').forEach((popup) => {
    popup.classList.remove('open');
  });

  footerBtns && footerBtns.classList.remove('tour-open');

  const url = new URL(window.location.href);
  if (url.searchParams.has('masterplan')) {
    url.searchParams.delete('masterplan');
    window.history.pushState({}, '', url);
  }

  const bannerSection = document.querySelector('.banner');
  if (!bannerSection) {
    window.location.href = url.pathname + url.search + url.hash;
    return;
  }

  bannerSection.classList.remove('dn', 'hidden');
  const bannerButton = bannerSection.querySelector('.banner__button');
  if (bannerButton) bannerButton.style.opacity = '';

  bannerSection.querySelectorAll('video').forEach((video) => {
    video.currentTime = 0;
    video.play().catch(() => {});
  });
};

document.querySelectorAll('.home-link a').forEach((homeLink) => {
  homeLink.addEventListener('click', (e) => {
    e.preventDefault();
    showIntroBanner();
  });
});

window.addEventListener("message", function (event) {
  if (event.data && event.data.type === "GO_HOME") {
    showIntroBanner();
  }
});

const toursLinks = document.querySelectorAll('.tours-link')
toursLinks.forEach(toursLink => {

  toursLink && toursLink.addEventListener('click', (e) => {
    if (!isBookModal) {
      e.preventDefault()
      const iframe = document.querySelector('.spinner iframe');
      const headerPopup = document.querySelector('.header__popup');
      if (iframe && headerPopup) {
        dismissIntroBanner();

        footerBtns && footerBtns.classList.add('tour-open')

        iframe.contentWindow.postMessage(
          { type: "OPEN_SPINNER_TOUR" },
          window.location.origin
        );

        headerPopup.classList.remove('open');
      }
    } else {
      bookDemoModal()
    }
  })
})



const contacts = document.querySelectorAll('.popup__contact');
const modals = document.querySelectorAll('.popup__simple')

modals.length && modals.forEach(modal => {
  const wrapper = modal.querySelector('.popup__simple-wrapper');
  modal.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      modal.classList.remove('open');
    }
  });
})

contacts.length && contacts.forEach(contact => {
  const wrapperContact = contact.querySelector('.popup__contact-wrapper');
  contact.addEventListener('click', (e) => {
    if (!wrapperContact.contains(e.target)) {
      contact.classList.remove('open');
    }
  });
})

document.addEventListener("DOMContentLoaded", function () {

  const popup = document.querySelector(".popup__simple.video");

  if (!popup) return;

  const video = popup.querySelector(".popup__simple-video");
  const playBtn = popup.querySelector(".popup__simple-play");
  const preview = popup.querySelector(".popup__simple-prev");
  const closeBtn = popup.querySelector(".popup__simple-close");

  // Swap to the mobile file on small screens (same breakpoint as the banner video)
  // Vimeo embeds are iframes: load on play, unload on close to stop playback
  const isEmbed = video.tagName === "IFRAME";
  const desktopSrc = isEmbed ? video.dataset.src : video.getAttribute("src");
  const mobileSrc = video.dataset.srcMobile;
  const mobileQuery = window.matchMedia("(max-width: 900px)");

  const currentSrc = () => (mobileSrc && mobileQuery.matches ? mobileSrc : desktopSrc);

  const syncVideoSrc = () => {
    if (isEmbed) return;
    const src = currentSrc();
    if (video.getAttribute("src") !== src) video.setAttribute("src", src);
  };

  syncVideoSrc();

  playBtn.addEventListener("click", function () {
    syncVideoSrc();
    playBtn.style.display = "none";

    if (preview) {
      preview.style.display = "none";
    }

    video.style.display = "block";

    if (isEmbed) {
      video.setAttribute("src", currentSrc() + (currentSrc().indexOf("?") > -1 ? "&" : "?") + "autoplay=1");
      return;
    }

    video.currentTime = 0;
    video.play();
  });

  closeBtn.addEventListener("click", function () {

    if (isEmbed) {
      video.removeAttribute("src");
    } else {
      video.pause();
      video.currentTime = 0;
    }

    playBtn.style.display = "block";

    if (preview) {
      preview.style.display = "block";
    }

    video.style.display = "none";
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const PanzoomModule = require("@panzoom/panzoom");
  const Panzoom = PanzoomModule.default || PanzoomModule;

  const initPopupGallery = (root) => {
    if (!root) return;

    const img = root.querySelector(".popup__gallery-img");
    const stage = root.querySelector(".popup__gallery-stage");
    const thumbs = Array.prototype.slice.call(
      root.querySelectorAll(".popup__gallery-thumb")
    );
    const currentEl = root.querySelector(".popup__gallery-current");
    const nameEl = root.querySelector(".popup__gallery-name");
    const prevBtn = root.querySelector(".popup__gallery-prev");
    const nextBtn = root.querySelector(".popup__gallery-next");
    const isFloorplan = root.classList.contains("floorplan");

    if (!img || !thumbs.length) return;

    let index = 0;
    let panzoom = null;

    if (isFloorplan && stage) {
      const panParent = root.querySelector(".popup__gallery-pan") || stage;
      // Parent matches the img box so contain:"outside" clamps pan without
      // forcing minScale > 1 (unlike using the larger stage as parent).
      panzoom = Panzoom(img, {
        maxScale: 10,
        minScale: 1,
        startScale: 1,
        contain: "outside",
        panOnlyWhenZoomed: true,
        cursor: "grab",
        step: 0.4,
      });
      panParent.addEventListener("wheel", panzoom.zoomWithWheel);
      img.addEventListener("load", () => {
        panzoom.reset({ animate: false });
      });
    }

    const resetZoom = () => {
      if (panzoom) {
        panzoom.reset({ animate: false });
      }
    };

    const show = (i) => {
      index = (i + thumbs.length) % thumbs.length;

      const thumb = thumbs[index];

      img.src = thumb.getAttribute("data-full") || img.src;
      img.alt = thumb.getAttribute("data-alt") || "";
      img.setAttribute("data-index", String(index));

      resetZoom();

      if (currentEl) {
        currentEl.textContent = String(index + 1);
      }

      if (nameEl) {
        nameEl.textContent = thumb.getAttribute("data-title") || "";
      }

      thumbs.forEach((t, ti) => {
        if (ti === index) {
          t.classList.add("is-active");
        } else {
          t.classList.remove("is-active");
        }
      });
    };

    prevBtn && prevBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      show(index - 1);
    });

    nextBtn && nextBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      show(index + 1);
    });

    thumbs.forEach((t) => {
      t.addEventListener("click", (e) => {
        e.stopPropagation();
        show(Number(t.getAttribute("data-index")) || 0);
      });
    });

    document.addEventListener("keydown", (e) => {
      if (!root.classList.contains("open")) return;

      if (e.key === "ArrowLeft") show(index - 1);
      if (e.key === "ArrowRight") show(index + 1);
      if (e.key === "Escape") root.classList.remove("open");
    });

    const mo = new MutationObserver(() => {
      if (root.classList.contains("open")) {
        show(0);
      } else {
        resetZoom();
      }
    });

    mo.observe(root, {
      attributes: true,
      attributeFilter: ["class"]
    });
  };

  Array.prototype.forEach.call(
    document.querySelectorAll(
      ".popup__simple.gallery, .popup__simple.floorplan"
    ),
    initPopupGallery
  );
});

const footerBtns = document.querySelector('.footer__buttons')
window.addEventListener("message", function (event) {
  if (event.data.type === "SPINNER_IS_OPEN") {
    footerBtns && footerBtns.classList.remove('tour-open')
  }
});
window.addEventListener("message", function (event) {
  if (event.data.type === "TOUR_IS_OPEN") {
    footerBtns && footerBtns.classList.add('tour-open')
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const aboutPopup = document.querySelector(".popup__simple.about");
  const aboutText = aboutPopup && aboutPopup.querySelector(".about-content .text");
  if (!aboutText) return;

  const SimpleBarModule = require("simplebar");
  const SimpleBar = SimpleBarModule.default || SimpleBarModule;
  const aboutScroll = new SimpleBar(aboutText, { autoHide: false });

  const refreshAboutScroll = () => {
    requestAnimationFrame(() => {
      aboutScroll.recalculate();
    });
  };

  refreshAboutScroll();

  const aboutObserver = new MutationObserver(() => {
    if (aboutPopup.classList.contains("open")) {
      refreshAboutScroll();
    }
  });

  aboutObserver.observe(aboutPopup, {
    attributes: true,
    attributeFilter: ["class"]
  });

  window.addEventListener("resize", refreshAboutScroll);
});